/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import SoftButton from "components/SoftComponents/SoftButton";
import { Link } from "react-router-dom";

function NewAssignmentsCard({ bgColor = "white", assignment_count = 14 }) {

    return (
        <SoftBox height="100%" display="flex" flexDirection="column" justifyContent="center" alignItems="center" variant="gradient" sx={({ palette: { white }, functions: { rgba } }) => ({ borderRadius: '20px', backgroundColor: rgba(white.main, 0.8) })}>
            <SoftBox display="flex" flex={1} flexDirection="row" p={{xxs: 1, sm: 2}} height='60%'>
                <SoftBox display="flex" flex={4} justifyContent="flex-end" alignItems="flex-end" pr={3}>
                    <SoftTypography fontWeight="bold" sx={{ fontSize: '80px', lineHeight: 0.9 }}>{assignment_count}</SoftTypography>
                </SoftBox>
                <SoftBox flex={8} display="flex" justifyContent="flex-end" alignItems="flex-end" sx={{ minWidth: '210px', maxWidth: '260px' }}>
                    <SoftTypography variant="body2">
                        Outstanding assignments that have not been resolved.
                    </SoftTypography>
                </SoftBox>
            </SoftBox>
            <SoftBox height='40%' alignContent="center" sx={{ minWidth: '100%' }}>
                <SoftBox display="flex" justifyContent="center">
                    <SoftButton sx={{ m: 1, minWidth: "50% !important" }} variant="gradient" color="primary" component={Link} to="/operations/assignments">
                        View Assignments
                    </SoftButton>
                </SoftBox>
            </SoftBox>
        </SoftBox>
    );
}

// Typechecking props for the NewAssignmentsCard
NewAssignmentsCard.propTypes = {
    bgColor: PropTypes.oneOf([
        "white",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
        "dark",
    ]),
    assignment_count: PropTypes.number,
};

export default NewAssignmentsCard;
